/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
import React from 'react';

import { MenuItem } from '@react/react-spectrum/Menu';
import DropdownButton from '@react/react-spectrum/DropdownButton';
import ChevronDown from '@react/react-spectrum/Icon/ChevronDown';
import ViewCard from '@react/react-spectrum/Icon/ViewCard';
import ViewList from '@react/react-spectrum/Icon/ViewList';
import { defineMessages, useIntl } from 'react-intl';

import classes from './ViewSelector.scss';

const messages = defineMessages({
    labelCardView: {
        id: 'label.cardView',
        defaultMessage: 'Card View'
    },
    labelListView: {
        id: 'label.listView',
        defaultMessage: 'List View'
    }
});

const ViewSelector = props => {
    const { formatMessage } = useIntl();

    return (
        <DropdownButton
            className={classes.root}
            label={<ViewCard size="M" className={classes.icon} />}
            alignRight
            icon={<ChevronDown />}
            {...props}
        >
            <MenuItem role="menuitemradio" key={0} value="card" icon={<ViewCard />}>
                {formatMessage(messages.labelCardView)}
            </MenuItem>
            <MenuItem role="menuitemradio" key={1} value="list" icon={<ViewList />}>
                {formatMessage(messages.labelListView)}
            </MenuItem>
        </DropdownButton>
    );
};

export default ViewSelector;
